import { Link } from "react-router-dom";
import { useTenant } from "@/hooks/useTenant";
import { openCookiePreferences } from "@/lib/cookieConsent";

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
  </svg>
);

const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);

const Footer = () => {
  const tenant = useTenant();
  return (
  <footer className="bg-background text-foreground border-t border-border py-10 mt-12">
    <div className="container mx-auto px-4">
      <div className="max-w-md mx-auto text-center">
        <h3 className="font-serif text-base font-medium text-foreground mb-3">Explore</h3>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-muted-foreground">
          <Link to="/properties" className="hover:text-foreground transition-colors">Browse Rentals</Link>
          <Link to="/areas" className="hover:text-foreground transition-colors">Explore Areas</Link>
          <Link to="/about" className="hover:text-foreground transition-colors">About</Link>
        </nav>
      </div>

      {(tenant.instagramUrl || tenant.facebookUrl) && (
        <div className="flex items-center justify-center gap-4 mt-8">
          {tenant.instagramUrl && (
            <a
              href={tenant.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <InstagramIcon />
            </a>
          )}
          {tenant.facebookUrl && (
            <a
              href={tenant.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <FacebookIcon />
            </a>
          )}
        </div>
      )}
      <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground mt-4">
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy Policy
        </Link>
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms of Use
        </Link>
        <Link to="/cookies" className="hover:text-foreground transition-colors">
          Cookie Policy
        </Link>
        <Link to="/privacy-request" className="hover:text-foreground transition-colors">
          Your Privacy Choices
        </Link>
        <Link to="/contact" className="hover:text-foreground transition-colors">
          Contact
        </Link>
      </nav>
      <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-muted-foreground mt-3">
        <button
          type="button"
          onClick={openCookiePreferences}
          className="hover:text-foreground transition-colors"
        >
          Cookie preferences
        </button>
        <Link to="/privacy-request?type=opt_out" className="hover:text-foreground transition-colors">
          Do Not Sell or Share My Personal Information
        </Link>
      </nav>
      <p className="mt-4 text-center text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} {tenant.siteName}. All rights reserved.
      </p>
    </div>
  </footer>
  );
};

export default Footer;
